// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1DTBZ","label":"Section_label__UtZ8J","contentWrap":"Section_contentWrap__2T01A","footer":"Section_footer__17IWd","footerInner":"Section_footerInner__2HRwY"};